var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarlendericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 1C5 0.447715 4.55228 0 4 0C3.44772 0 3 0.447715 3 1V2H2C1.17157 2 0.5 2.67157 0.5 3.5V5H14.5V3.5C14.5 2.67157 13.8284 2 13 2H12.0001V1C12.0001 0.447715 11.5524 0 11.0001 0C10.4478 0 10.0001 0.447715 10.0001 1V2H5V1ZM14.5 6.25H0.5V12.5C0.5 13.3284 1.17157 14 2 14H13C13.8284 14 14.5 13.3284 14.5 12.5V6.25Z",
    fill: "#CBCED4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarlendericon);
export default __webpack_public_path__ + "static/media/carlendericon.6d04b931c474a8f6335a35fc3ca6f96e.svg";
export { ForwardRef as ReactComponent };